import React, { Component } from 'react';
import {Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap';

export class MessagePanelSmall extends Component {

  render() {
    return (
      <div className="ibox float-e-margins">
          <div className="ibox-title">
              <h5>Messages</h5>

          </div>
          <div className="ibox-content ibox-heading">
              <h3><i className="fa fa-envelope-o"></i> New messages</h3>
              <small><i className="fa fa-tim"></i> You have 22 new messages and 16 waiting in draft folder.</small>
          </div>
          <div className="ibox-content">
              <div className="feed-activity-list">

                  <div className="feed-element">
                      <div>
                          <small className="pull-right text-navy">1m ago</small>
                          <strong>System Message</strong>
                          <div>Driver Jose Gutierrez is 45 minutes ahead of schedule. Dropoff location notified and will try and unload early.</div>
                      </div>
                  </div>

                  <div className="feed-element">
                      <div>
                          <small className="pull-right">2m ago</small>
                          <strong>Email: john.schwarz@insuranceco.com </strong>
                          <div>Subject: I uploaded New Certificates of Insurance for Driver Margaret Johnson to NXXT</div>

                      </div>
                  </div>

              </div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MessagePanelSmall.js